export const ConfigData = [
  {
    id: "max_geofence_area",
    name: "Max geofence area (in meters)",
    isShow: true,
    width: "300px",
    filter: true,
  },
  {
    id: "max_available_seat",
    name: "Max available seat",
    isShow: true,
    width: "250px",
    filter: true,
  },
  {
    id: "max_order_time",
    name: "Last Order Time - n hour(s) before the departure time.",
    isShow: true,
    width: "400px",
    filter: true,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["View Details"],
    permission: {
      ["View Details"]: {
        id: "View Details",
        permission: ["bus_booking.access_maximum_config"]

      }
    },
  },
];
